__turbopack_context__.v({
  "balance": "owned-course-plans-module__HA2nwa__balance",
  "balances": "owned-course-plans-module__HA2nwa__balances",
  "cellLabel": "owned-course-plans-module__HA2nwa__cellLabel",
  "cellNumber": "owned-course-plans-module__HA2nwa__cellNumber",
  "counts": "owned-course-plans-module__HA2nwa__counts",
  "course": "owned-course-plans-module__HA2nwa__course",
  "courseHeading": "owned-course-plans-module__HA2nwa__courseHeading",
  "details": "owned-course-plans-module__HA2nwa__details",
  "empty": "owned-course-plans-module__HA2nwa__empty",
  "heading": "owned-course-plans-module__HA2nwa__heading",
  "hint": "owned-course-plans-module__HA2nwa__hint",
  "history": "owned-course-plans-module__HA2nwa__history",
  "inactive": "owned-course-plans-module__HA2nwa__inactive",
  "list": "owned-course-plans-module__HA2nwa__list",
  "listHeading": "owned-course-plans-module__HA2nwa__listHeading",
  "meta": "owned-course-plans-module__HA2nwa__meta",
  "more": "owned-course-plans-module__HA2nwa__more",
  "note": "owned-course-plans-module__HA2nwa__note",
  "plan": "owned-course-plans-module__HA2nwa__plan",
  "reserved": "owned-course-plans-module__HA2nwa__reserved",
  "root": "owned-course-plans-module__HA2nwa__root",
  "stamp": "owned-course-plans-module__HA2nwa__stamp",
  "stampCaption": "owned-course-plans-module__HA2nwa__stampCaption",
  "stampCell": "owned-course-plans-module__HA2nwa__stampCell",
  "stampGrid": "owned-course-plans-module__HA2nwa__stampGrid",
  "summary": "owned-course-plans-module__HA2nwa__summary",
  "toggle": "owned-course-plans-module__HA2nwa__toggle",
  "unavailable": "owned-course-plans-module__HA2nwa__unavailable",
  "used": "owned-course-plans-module__HA2nwa__used",
});
